<div class="nh-vezerlok">
  <ion-input class="nh-nap" fill="outline" type="date" label="Nap" labelPlacement="stacked"
             [(ngModel)]="nap" (ionChange)="betolt()"></ion-input>
  <ion-segment [(ngModel)]="kor" class="nh-kor">
    <ion-segment-button value="rendelt"><ion-label>Ebédet rendelt</ion-label></ion-segment-button>
    <ion-segment-button value="etkezo"><ion-label>Étkező</ion-label></ion-segment-button>
    <ion-segment-button value="mind"><ion-label>Minden hiányzó</ion-label></ion-segment-button>
  </ion-segment>
  <ion-toggle [(ngModel)]="csakReggelOta" justify="start" labelPlacement="end">Csak reggel óta hiányzók</ion-toggle>
  <ion-button size="small" fill="outline" color="medium" (click)="betolt()" [disabled]="fut">
    <ion-icon slot="start" name="refresh-outline"></ion-icon>Frissítés
  </ion-button>
</div>

<ion-spinner name="crescent" *ngIf="fut"></ion-spinner>
<ion-note color="danger" *ngIf="hiba && !fut" class="nh-megj">{{ hiba }}</ion-note>

<ng-container *ngIf="adat && !fut">
  <div class="nh-osszegzes">
    <span><b>{{ adat.osszesites.rendelok }}</b> tanuló rendelt ebédet erre a napra,
      ebből <b>{{ adat.osszesites.rendelo_hianyzok }}</b> hiányzik
      (<b>{{ adat.osszesites.rendelo_reggel_ota }}</b> reggel óta).</span>
    <span>Összes hiányzó: <b>{{ adat.osszesites.hianyzok }}</b>
      (reggel óta: <b>{{ adat.osszesites.reggel_ota }}</b>).</span>
  </div>
  <!--  A még be nem írt óra NEM jelenti, hogy mindenki ott volt: ezt ki kell mondani. -->
  <ion-note class="nh-megj" [color]="adat.osszesites.nem_konyvelt_orak ? 'warning' : 'medium'">
    Az aznapi {{ adat.osszesites.orak }} órából <b>{{ adat.osszesites.konyvelt_orak }}</b> könyvelt;
    <b>még nem könyvelt órák: {{ adat.osszesites.nem_konyvelt_orak }}</b>.
    A hiányzás csak a már beírt órákról ismert — a nem könyvelt órákon lévő hiányzók még nem látszanak.
  </ion-note>
  <ion-note class="nh-megj" color="medium" *ngIf="!adat.osszesites.rendelok && kor === 'rendelt'">
    Erre a napra nincs rögzített ebédrendelés. Az <b>Étkező</b> fül az étkezési belépéssel
    rendelkezőket is mutatja, a <b>Minden hiányzó</b> pedig az iskola összes aznapi hiányzóját.
  </ion-note>

  <div class="nh-tabla-doboz" *ngIf="sorok.length">
    <table class="nh-tabla">
      <thead>
        <tr><th>Név</th><th>Osztály</th><th>Órák (hiányzott: piros)</th><th>Ebéd</th><th></th></tr>
      </thead>
      <tbody>
        <tr *ngFor="let t of sorok" [class.nh-reggel]="t.reggel_ota">
          <td>{{ t.nev }}</td>
          <td>{{ t.osztaly }}</td>
          <td>
            <span *ngFor="let o of t.orak" class="nh-ora"
                  [class.hiany]="o.hianyzott" [class.jelen]="o.konyvelt && !o.hianyzott"
                  [class.nincs]="!o.konyvelt" [title]="oraCim(o)">{{ o.ora }}</span>
            <div class="nh-halvany">hiányzott: {{ t.hianyzott_orak.join(', ') }}. óra<span *ngIf="t.nem_konyvelt_orak"> · {{ t.nem_konyvelt_orak }} óra még nincs beírva</span></div>
          </td>
          <td>
            <span *ngIf="t.ebed">rendelt<span *ngIf="t.menu" class="nh-halvany"> ({{ t.menu }})</span></span>
            <span *ngIf="!t.ebed && t.belepett" class="nh-halvany">étkező, erre a napra nincs rendelés</span>
            <span *ngIf="!t.ebed && !t.belepett" class="nh-halvany">—</span>
          </td>
          <td>
            <ion-badge color="danger" *ngIf="t.reggel_ota">reggel óta hiányzik</ion-badge>
            <ion-badge color="medium" *ngIf="!t.reggel_ota">óráról hiányzik</ion-badge>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <ion-note color="medium" class="nh-megj" *ngIf="!sorok.length && (adat.osszesites.rendelok || kor !== 'rendelt')">
    Nincs a szűrésnek megfelelő hiányzó ezen a napon.
  </ion-note>
  <ion-note color="medium" class="nh-megj">
    <b>Reggel óta hiányzik</b>: az aznapi első órája be van írva és hiányzott rajta, és egyetlen
    beírt óráján sem volt jelen. A napközi nem számít bele.
  </ion-note>
</ng-container>
